<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">

      <!--Breadcrumbs and title embedded within below data page-->
      <div class="container">
        <partner-breadcrumbs />
      </div>

      <div class="tabs">
        <div class="tab-header">
          <button v-if="showConvHistoryTab" class="tab-button"
            @click="this.$router.push('/partner/conversation-history/voice')"
            :class="{ active: activeTab === 'conv-history' }">Conversation History</button>
          <!-- <button class="tab-button" @click="this.$router.push('/partner/view-bot')"
            :class="{ active: activeTab === 'bot-config' }">Bot Configuration</button> -->
          <button class="tab-button" @click="this.$router.push('/partner/analytics')"
            :class="{ active: activeTab === 'bot-analytics' }">Analytics</button>
        </div>

        <div class="tab-content">
          <div v-if="activeTab === 'conv-history'">
            <!--Refresh history button-->
            <v-container>
              <!-- Label + Radio Options -->
              <v-row justify="start">
                <v-col sm="auto">
                  <span class="text-subtitle-1" style="font-weight: bold;">Date range:</span>
                </v-col>
                <v-col sm="auto">
                  <v-radio-group v-model="range" inline hide-details>
                    <v-radio label="No filter" value="1"></v-radio>
                    <v-radio label="Last 7 days" value="7"></v-radio>
                    <v-radio label="Last 30 days" value="30"></v-radio>
                    <v-radio label="Custom" value="Custom"></v-radio>
                  </v-radio-group>
                </v-col>


                <!-- Show custom date fields if selected -->
                <v-col sm="auto" v-if="range === 'Custom'">
                  <v-text-field v-model="startDate" label="Start Date" type="date" density="compact" variant="outlined"
                    clearable />
                </v-col>
                <v-col sm="auto" v-if="range === 'Custom'">
                  <v-text-field v-model="endDate" label="End Date" type="date" density="compact" variant="outlined"
                    clearable />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="auto">
                  <v-btn color="blue-grey-darken-2" class="text-none px-6 mt-n3" height="40" rounded="xl"
                    @click="refreshHistory">
                    SUBMIT
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>


            <!--Conversation logs table-->
            <v-container v-if="conversationLogs.length > 0">
              <v-card class="pa-4">
                <div class="table-wrapper">
                  <v-table density="compact" hover class="custom-table">
                    <thead>
                      <tr>
                        <th v-for="header in headers" :key="header.key" class="text-subtitle-1 font-weight-bold"
                          :style="{ textAlign: header.align || 'left' }">
                          {{ header.title }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in conversationLogs" :key="item.conversationId">
                        <td class="py-2">{{ item.calledEntity.phoneNumber }}</td>
                        <td class="py-2">{{ item.callingEntity.phoneNumber }}</td>
                        <td class="py-2">{{ item.connectTime }}</td>
                        <td class="text-center">{{ item.endTime }}</td>
                        <td class="py-2">{{ item.durationSeconds }}s</td>
                        <td class="py-2">{{ item.calledEntity.type }}</td>
                        <td class="text-center">
                          <router-link
                            :to="{ path: '/partner/conversation-transcript', query: { call_id: item.callId } }"
                            class="text-primary font-weight-bold text-decoration-none">View Transcript</router-link>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </v-card>
            </v-container>
            <v-container v-else-if="dataLoaded" class="text-center pa-5">
              <p>Records are currently not available. For more information, please email us at <a
                  href="mailto:support@trimate.ai">support@trimate.ai</a>.</p>
            </v-container>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'
import PartnerBreadcrumbs from './PartnerBreadcrumbs.vue'
import { medicalBotIds } from "@/config/medicalBots.js"

export default {
  name: 'ViewConversationHistory',
  components: {
    SideBar,
    PartnerBreadcrumbs
  },
  data() {
    return {
      activeTab: 'conv-history', // Default active tab
      range: '1',
      startDate: '',
      endDate: '',
      headers: [

        { title: 'Called Number', key: 'calledNumber', align: 'start' },
        { title: 'Calling Number', key: 'callingNumber' },
        { title: 'Start Time', key: 'connectTime' },
        { title: 'End Time', key: 'endTime' },
        { title: 'Duration', key: 'durationSeconds' },
        { title: 'Handled By', key: 'calledEntity.type' },
        { title: 'View', key: 'actions', sortable: false, align: 'center' }
      ],
      conversationLogs: [],
      showConvHistoryTab: true,
      dataLoaded: false
    }
  },
  methods: {
    async fetchConversationData() {

      // If customer is not selected, go to dashboard
      if (!localStorage.getItem('customerGUID')) {
        this.$router.push('/partner/dashboard');
      }
      // If bot is not selected go to customer
      const botId = localStorage.getItem("botID") || '';
      if (!botId) {
        this.$router.push('/partner/customer');
      }

      const params = new URLSearchParams({
        range: this.range,
        start_date: this.startDate,
        end_date: this.endDate
      })
      const url = `${process.env.VUE_APP_VORTEX_PORTAL_WS}/bots/${botId}/calls`;

      try {
        const response = await fetch(`${url}?${params.toString()}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${token}`,
          }
        })

        if (!response.ok) {
          console.error('Fetch conversation history failed with error:', response.statusText)
        }
        const data = await response.json();

        if (data && data.data && data.data.callLogs && data.data.callLogs.length > 0) {
          this.conversationLogs = [...data.data.callLogs].sort(
            (a, b) => this.setupTimeToTimestamp(b.setupTime) - this.setupTimeToTimestamp(a.setupTime)
          );
        } else {
          console.warn('Unexpected data structure:', data);
          this.conversationLogs = [];
        }

      } catch (error) {
        console.error('Error fetching conversation data:', error);
      } finally {
        this.dataLoaded = true;
      }
    },

    refreshHistory() {
      this.fetchConversationData();
    },

    setupTimeToTimestamp(setupTime) {
      const [datePart, timePart, ampm] = setupTime.trim().split(' ');

      const [day, month, year] = datePart.split('/').map(Number);
      let [hour, minute, second] = timePart.split(':').map(Number);

      if (ampm === 'PM' && hour !== 12) hour += 12;
      if (ampm === 'AM' && hour === 12) hour = 0;

      return new Date(
        year,
        month - 1,
        day,
        hour,
        minute,
        second
      ).getTime();
    }

  },
  mounted() {
    const botId = localStorage.getItem("botID") || '';
    if (medicalBotIds.includes(botId)) {
      this.showConvHistoryTab = false;
    }
    this.fetchConversationData();
  }
}
</script>


<style scoped>
hr.h1 {
  margin-bottom: 0px;
}
</style>